import styled from 'styled-components';
import { AvForm } from 'availity-mobx-reactstrap-validation';

export default styled(AvForm)`
  padding: 0 2rem 2rem 2rem;
`;
